import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';

import { generateFormattedDateHeaders } from '../../helpers/helpers'

class DateHeadings extends Component {
  render() {
    const {
      startOfSelectedWeek,
      includeWeekend
    } = this.props;

    const formattedDates = generateFormattedDateHeaders(startOfSelectedWeek, includeWeekend);

    return (
      <>
        <Grid item xs={2} />
        {formattedDates.map(date => (
          <Grid
            item
            xs={includeWeekend ? 1 : 2}
            className={`dateLabel ${
              includeWeekend ? 'customGridItem includeWeekend' : ''
            }`}
            key={date}
          >
            {date}
          </Grid>
        ))}
        <Grid item xs={12}>
          <hr />
        </Grid>
      </>
    );
  }
}

DateHeadings.propTypes = {
  startOfSelectedWeek: PropTypes.instanceOf(Date).isRequired,
  includeWeekend: PropTypes.bool.isRequired,
};

export default DateHeadings;
